// src/pages/GamesPage.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './GamesPage.css'; 

// Importation des composants de jeu
import SnakeGame from '../components/games/SnakeGame'; 
import FlipperGame from '../components/games/FlipperGame'; // <<< NOUVEL IMPORT
// etc.

function GamesPage() {
  const pageTitle = "Zone de Jeux Secrète | INFO COLAB";
  const pageDescription = "Détendez-vous avec notre collection de mini-jeux cachés. Uniquement pour les curieux explorateurs du web !";
  const siteUrl = "https://infocolab.com";
  const pageUrl = `${siteUrl}/jeux-secrets-info-colab`;

  const [activeGameId, setActiveGameId] = useState(null);

  const games = [
    { 
      id: 'snake', 
      icon: '🐍', 
      title: 'Snake Classique', 
      description: 'Le jeu du serpent intemporel. Mangez pour grandir, mais ne vous mordez pas la queue !',
      status: 'Jouer',
      component: <SnakeGame /> 
    },
    { 
      id: 'flipper', 
      icon: '🕹️', 
      title: 'Flipper Rétro', 
      description: 'Faites grimper le score dans ce classique des salles d\'arcade simplifié.', // Description mise à jour
      status: 'Jouer', // <<< Mis à jour pour être jouable
      component: <FlipperGame /> // <<< Ajout du composant Flipper
    },
    { 
      id: 'pixel-puzzler', 
      icon: '👾', 
      title: 'Pixel Puzzler', 
      description: 'Assemblez les pièces pour révéler l\'image pixelisée cachée.',
      status: 'Bientôt disponible',
      component: null
    },
    { 
      id: 'code-breaker', 
      icon: '🧠', 
      title: 'Code Breaker', 
      description: 'Testez votre logique et déchiffrez le code secret le plus vite possible.',
      status: 'Prochainement',
      component: null
    },
    { 
      id: 'palette-perfect', 
      icon: '🎨', 
      title: 'Palette Perfect', 
      description: 'Un défi pour les yeux : trouvez la nuance exacte dans ce jeu de couleurs.',
      status: 'En cours de création',
      component: null
    },
    {
      id: 'space-shooter',
      icon: '🚀',
      title: 'Space Shooter Express',
      description: 'Défendez la galaxie dans ce mini-jeu de tir spatial rapide et fun.',
      status: 'Concept',
      component: null
    },
    {
      id: 'memory-master',
      icon: '🃏',
      title: 'Memory Master',
      description: 'Retournez les cartes et testez votre mémoire pour trouver toutes les paires.',
      status: 'À l\'étude',
      component: null
    },
    {
      id: 'word-weaver',
      icon: '✍️',
      title: 'Word Weaver',
      description: 'Formez le plus de mots possible à partir d\'une sélection de lettres.',
      status: 'Idée',
      component: null
    }
  ];

  const handlePlayOrToggleGame = (gameId) => {
    const gameToPlay = games.find(g => g.id === gameId);
    if (gameToPlay && gameToPlay.status === 'Jouer') {
      setActiveGameId(prevActiveGameId => prevActiveGameId === gameId ? null : gameId);
    }
  };

  const currentGame = activeGameId ? games.find(g => g.id === activeGameId) : null;

  if (currentGame && currentGame.component) {
    return (
      <>
        <Helmet>
          <title>{currentGame.title} | {pageTitle}</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="container games-page-container game-active-mode">
          <header className="active-game-header">
            <h2>{currentGame.title}</h2>
            <button 
              onClick={() => setActiveGameId(null)} 
              className="btn btn-outline-secondary btn-close-game"
              aria-label="Fermer le jeu"
            >
              &times; Retour aux jeux
            </button>
          </header>
          <div className="active-game-wrapper">
            {currentGame.component}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <div className="container games-page-container">
        <header className="games-page-header">
          <h1>Bienvenue dans la Zone de Jeux ! 🕹️</h1>
          <p>Psst... Vous avez trouvé notre jardin secret numérique. Choisissez votre défi et amusez-vous bien !</p>
        </header>

        <div className="games-grid">
          {games.map(game => (
            <div key={game.id} className="mini-game-card">
              <span className="game-card-icon" role="img" aria-label={game.title}>{game.icon}</span>
              <h3>{game.title}</h3>
              <p>{game.description}</p>
              <button 
                className={`btn ${game.status === 'Jouer' ? 'btn-primary' : 'btn-secondary'}`} 
                disabled={game.status !== 'Jouer'}
                onClick={() => handlePlayOrToggleGame(game.id)}
              >
                {activeGameId === game.id ? 'Fermer le Jeu' : (game.status === 'Jouer' ? 'Jouer Maintenant' : game.status)}
              </button>
            </div>
          ))}
          
          <div className="mini-game-card placeholder-card">
            <h3>Plus de Surprises</h3>
            <p>De nouveaux jeux et défis arriveront bientôt. Revenez explorer !</p>
            <span className="game-icon-large">🎲</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default GamesPage;